const prefix = 'promotions';

export const SET_PROMOTION = `${prefix}/SET_PROMOTION`;
export const RESET_PROMOTION = `${prefix}/RESET_PROMOTION`;
